import { FC } from "react"
import { parseDate, getWeekSlotsTillMonthEnd } from "../../utils/helpers"
import { CalendarDateInfo } from "./Calendar"

interface CalendarCellProps {
    date: Date
    CellComponent: FC<{ dateInfo: CalendarDateInfo }>
    maxDisplayedWeeks?: number
    ControlsComponent?: FC
    value?: Date 
}

export const CalendarCells: FC<CalendarCellProps> = ({
    date, 
    CellComponent, 
    maxDisplayedWeeks, 
    ControlsComponent,
    value
}) => {

    const now = new Date()

    const TODAY = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const REFERENCE = date
    const MONTH_END_DATE = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const START_WEEKDAY = date.getDay()===0 ? 6 : date.getDay() - 1
    const START_FROM = date
    const MONTH_START_DATE = new Date(date.getFullYear(), date.getMonth(), 1)

    const caption = parseDate('November yyyy', MONTH_START_DATE)

    return (
        <>

        {/* CAPTION - MONTH NAME + CONTROLS */}
        <caption className="df aic" aria-hidden>
            <p className="text s24-600 left w-100 center" >{caption}</p>
            { ControlsComponent && (<ControlsComponent />)}
        </caption>

        {/* TABLE HEAD - DAY NAMES ROW */}
        <thead className="day-names row mb-6 w-100 df aic jcsb" aria-hidden>
            <tr className="week df aic jcsb w-100">
                {Array.from({length: 7}).map((_, dayOffset) => 
                    <th 
                        className="cell" 
                        key={dayOffset} 
                    >
                        <span 
                            className="text s16-600 softer upper center w-100"
                        >
                            {parseDate('Mon', new Date(2024, 10, 11 + dayOffset))}
                        </span>
                    </th>
                )}
            </tr>
        </thead>

        {/* TABLE BODY - WEEKS AS TABLE ROWS */}
        <tbody role="rowgroup" aria-label={caption}>
        {Array.from({length: (maxDisplayedWeeks ?? getWeekSlotsTillMonthEnd(START_FROM))}).map((_, weekOffset) => {

            const WEEK_DATE = new Date(
                START_FROM.getFullYear(),
                START_FROM.getMonth(),
                START_FROM.getDate() + (7 * weekOffset) - START_WEEKDAY
            )

            return WEEK_DATE.getTime() > MONTH_END_DATE.getTime() ? null : (
                <tr className="row week df aic jcsb" key={weekOffset} role="row">
                {/* days print */
                Array.from({length: 7}).map((_, dayOffset) => {

                    const CELL_DATE = new Date(
                        START_FROM.getFullYear(),
                        START_FROM.getMonth(),
                        START_FROM.getDate() + dayOffset + (7 * weekOffset) - START_WEEKDAY
                    )

                    CELL_DATE.setHours(0, 0, 0, 0)

                    const DATE_INFO: CalendarDateInfo = {
                        dateObject: CELL_DATE,
                        isBeforeToday: (CELL_DATE.getTime() < REFERENCE.getTime()),
                        isBeforeMonthStart: (CELL_DATE.getTime() < MONTH_START_DATE.getTime()),
                        isAfterMonthEnd: (CELL_DATE.getTime() > MONTH_END_DATE.getTime()),
                        isToday: (CELL_DATE.getTime() === TODAY.getTime()),
                        isWeekend: (CELL_DATE.getDay() === 6 || CELL_DATE.getDay() === 0),
                        isInThisMonth: (CELL_DATE.getMonth() === MONTH_START_DATE.getMonth()),
                        isSelected: (!!value && !isNaN(value.getTime()) && value.getDate() === CELL_DATE.getDate() && value.getMonth() === CELL_DATE.getMonth() && value.getFullYear() === CELL_DATE.getFullYear())
                    }

                    return (<CellComponent key={dayOffset} dateInfo={DATE_INFO}/>)
                })}
                </tr>
            )
        }
        )}
        </tbody>
        </>
    )
}